import { render } from "./prospect-import-modal.vue?vue&type=template&id=66fbc806"
import script from "./prospect-import-modal.vue?vue&type=script&lang=js"
export * from "./prospect-import-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__